<template>
  <div class="cashhero">
    <login-version2 />
  </div>
</template>

<script>
import LoginVersion2 from '@/views/user/include/LoginVersion2'

export default {
  name: 'Login',
  components: { LoginVersion2 },
  metaInfo: {
    title: 'Login',
    titleTemplate: '%s | Cash Hero',
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: 'Login' }
    ]
  }
}
</script>

<style scoped>

</style>
